// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IProcessedReturnedCheckDto } from './IProcessedReturnedCheckDto';
import {
    IProcessedReturnedCheckDtoFromJSON,
    IProcessedReturnedCheckDtoFromJSONTyped,
    IProcessedReturnedCheckDtoToJSON,
    IProcessedReturnedCheckDtoToJSONTyped,
} from './IProcessedReturnedCheckDto';

/**
 * 
 * @export
 * @interface IProcessedReturnedChecksDto
 */
export interface IProcessedReturnedChecksDto {
    /**
     * 
     * @type {Array<IProcessedReturnedCheckDto>}
     * @memberof IProcessedReturnedChecksDto
     */
    returned_checks?: Array<IProcessedReturnedCheckDto>;
}

/**
 * Check if a given object implements the IProcessedReturnedChecksDto interface.
 */
export function instanceOfIProcessedReturnedChecksDto(value: object): value is IProcessedReturnedChecksDto {
    return true;
}

export function IProcessedReturnedChecksDtoFromJSON(json: any): IProcessedReturnedChecksDto {
    return IProcessedReturnedChecksDtoFromJSONTyped(json, false);
}

export function IProcessedReturnedChecksDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IProcessedReturnedChecksDto {
    if (json == null) {
        return json;
    }
    return {
        
        'returned_checks': json['returned_checks'] == null ? undefined : ((json['returned_checks'] as Array<any>).map(IProcessedReturnedCheckDtoFromJSON)),
    };
}

export function IProcessedReturnedChecksDtoToJSON(json: any): IProcessedReturnedChecksDto {
    return IProcessedReturnedChecksDtoToJSONTyped(json, false);
}

export function IProcessedReturnedChecksDtoToJSONTyped(value?: IProcessedReturnedChecksDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'returned_checks': value['returned_checks'] == null ? undefined : ((value['returned_checks'] as Array<any>).map(IProcessedReturnedCheckDtoToJSON)),
    };
}

